import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select'

export default class extends Controller {
  static targets = ['code']

  connect() {
    this.tomSelect = new TomSelect(this.codeTarget, {
      searchField: ['value', 'text'],
      placeholder: 'Search by code or description...',
      allowEmptyOption: true,
      dropdownParent: 'body'
    })
  }

  disconnect() {
    this.tomSelect?.destroy()
  }
}
